import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ICorrelationCurve } from '@app/api/interfaces/chart-data/correlation-curve';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export enum FpCorrelationGraphActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
}

export interface FpCorrelationGraphActionGetData {
  type: FpCorrelationGraphActionType.GetData;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
}

export interface FpCorrelationGraphActionGetDataSuccesses {
  type: FpCorrelationGraphActionType.GetDataSuccesses;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  data: ICorrelationCurve[] | null;
}
export interface FpCorrelationGraphActionGetDataError {
  type: FpCorrelationGraphActionType.GetDataError;
  date: string | null;
  popupMainData: IFpCorrelationData | null;
  error: IApiBaseErrorResponse;
}
export interface FpCorrelationGraphActionToggleChartFullscreen {
  type: FpCorrelationGraphActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export type FpCorrelationGraphActions =
  | FpCorrelationGraphActionGetData
  | FpCorrelationGraphActionGetDataSuccesses
  | FpCorrelationGraphActionToggleChartFullscreen
  | FpCorrelationGraphActionGetDataError;
